import { Heading } from '@chakra-ui/react';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';

type SectionHeaderProps = {
  id?: string;
  text: string;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({ id, text }) => {
  const _id = id || text.toLowerCase().replace(/ +/g, '-');
  return (
    <Heading
      id={_id}
      letterSpacing={-0.8}
      fontFamily={FontFamily.HELVETICA_NOW_BOLD}
      fontWeight="normal"
      fontSize={['28px', '36px']}>
      {text}
    </Heading>
  );
};
